import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { authApiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
export const updateRole = async ({ roleId, payload }) => {
  const { data } = await authApiClient.put(`/roles/${roleId}`, payload);
  return data;
};

export const useUpdateRoleHandler = ({ onSuccess } = {}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: updateRole,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['auth-roles'] });
      dispatch(
        showSnackbar({
          message: 'Role updated successfully',
          severity: 'success',
        }),
      );
      onSuccess?.();
    },
    onError: (error) => {
      const message =
        error instanceof AxiosError
          ? error.response?.data?.errors?.message || error.message
          : 'Failed to update role';
      dispatch(showSnackbar({ message, severity: 'error' }));
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
  };
};
